import React, {Component} from 'react'
import {
    Card,
    Table,
    Button
} from 'antd';
import {getSubordinateKpiList} from '../../../request'
import {withRouter} from "react-router-dom";
import TransferModal from "../../../components/OA/TransferModal";
let columsKey = {
    currentPeriodName: '当前周期',
    userName: '员工',
    actions: '操作',
}
class Subordinate extends Component {
    employeeModal = React.createRef()
    surveyModal = React.createRef()
    state = {
        dataSource:[],
        dicList:{},
        SurveyQaList:[],
        columns:[],
        loading:false,
        visible:false,
        systemItem:{},
        formParam:{
            id:null,
            name:null
        },
        total:0,
        formDataParam:{
            name:''
        },
        detailDrawerVisible:false,
        editParam:{}
    };
    createColumns = (createKeys)=>{
        let columns = Object.keys(createKeys).map(item=>{
            let initObj = {
                title:createKeys[item],
                dataIndex:item,
                key:item,
                align:'left'
            }
            if(item=='actions'){
                return {
                    ...initObj,
                    fixed: 'right',
                    width: 280,
                    render: (text, record, index) => {
                        return (
                            <>

                                <Button type="link" size="small" onClick={() => (this.setKpi(record))}>设置KPI</Button>
                                <Button type="link" size="small" onClick={() => (this.setPerformance(record))}>绩效评估</Button>
                                <Button type="link" size="small" onClick={() => (this.setPeers(record))}>360环评人员</Button>

                            </>
                        )
                    }
                }
            }else{
                return initObj
            }
        })
        this.setState({
            columns,
        })
    }
    initTableDataList(){
        this.setState({ loading: true });
        console.log(this.state.formParam)
        getSubordinateKpiList({}).then(res=>{
            this.setState({
                loading: false,
                dataSource:res,
            })
        })
    }
    setKpi = (values)=>{
        this.props.history.push({
            pathname:`/oa/subordinate/kpidetail/${values.userId}`,
        })
    }
    setPerformance = (values)=>{
        this.props.history.push({
            pathname:`/oa/subordinate/performancedetail/${values.userId}`,
        })
    }
    setPeers = (values)=>{
        console.log(values,this.employeeModal)
        this.employeeModal.current.handleModalOpen({userId:values.userId,departmentShow:false})
    }
    componentDidMount(){
        console.log(this.props.history)
        this.createColumns(columsKey);
        this.initTableDataList()
    }
    render() {
        const { dataSource,columns, loading} = this.state;

        return (
            <>
                <Card title={'我的下级'} bordered={false} className={'card-fixed-head-wrap'}>
                    <Table
                        bordered={true}
                        size="small"
                        pagination={false}
                        dataSource={dataSource}
                        columns={columns}
                        rowKey={record=>record.id}
                        loading={loading}/>
                </Card>
                <TransferModal ref={this.employeeModal} from={'employee'}  handleCloseModal={(val)=>console.log(val)}/>

            </>

        )
    }
}
export default withRouter(Subordinate)